import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  OpenLoginSignUp,
  ResetLoginSignUp,
} from "../../../../../../Actions/ToggleSignupA";
import { OnLogin, OnRegister, OtherOption } from "../MiniComponents";
import UserInput from "./UserInput";
import { useState } from "react";
import { useEffect } from "react";
import { SubmitButton } from "../../../../LoginAndRegister";
import ContinueWithGoogle from "../LeftSide/ContinueWIth/ContinueWithGoogle";
import ReCAPTCHA from "react-google-recaptcha-v2";
import "./rightSide.css";
import { useAuthContext } from "../../../../../../context/authContext";

const SigninRightSide = ({
  TopLoginRegisterBtns,
  Credentials,
  setCredentials,
  PasswordError,
  captchaError,
  userType,
  Errors,
  setErrors
}) => {
  const Dispatch = useDispatch();
  const { AuthPageName } = useSelector((Store) => Store.ToggleSignupReducer);
  // const [Errors, setErrors] = useState();
  const { error } = useSelector((Store) => Store.LoginSignupReducer);
  console.log("userType in SigninRightSide is:",userType)

  const { setCaptcha } = useAuthContext();

  function onChange(value) {
    setCaptcha(value);
  }

  let SignInbtnColor =
    AuthPageName === "Sign Up"
      ? "bg-[#EAEFF4] text-black"
      : "bg-white text-[#A1A3EF]";
  let Gap = AuthPageName === "Sign Up" ? "gap-4 xl:gap-7" : "gap-1 xl:gap-2";
  let ButtonStyle = `flex items-center gap-5 justify-center
    border-[1px] border-[#FEFEFE]
  
    cursor-pointer  lg:min-w-[400px]  max-w-[625px]
    font-normal rounded-lg
    md:py-2                 xl:py-3 
    md:px-6     lg:px-10    xl:px-16    2xl:px-20 
    DropShadow`;
  
    // DropShadow
    let h4Style = `text-left font-normal  whitespace-nowrap 
        text-4xs md:text-[19px] lg:text-xs   xl:text-base  2xl:text-[30px]
        w-auto   md:w-[220px]   lg:w-[250px] xl:w-[290px]  2xl:w-[350px]`;

  useEffect(() => {
    setErrors(JSON.parse(JSON.stringify(error)));
  }, [error]);


  const OnClick = () => {
    Dispatch(OpenLoginSignUp("Sign In", true));
    setCredentials({
      Email: "",
      Password: "",
      ConfirmPassword: "",
      FirstName: "",
      LastName: "",
    });
  };

  const [otp, setOtp] = useState(new Array(4).fill("")); // Array for OTP inputs
  const [otpSent, setOtpSent] = useState("");
  const [otpVerified, setOtpVerified] = useState(false); // Controls Sign In button

  const handleOTPChange = (element, index) => {
    const value = element.value.replace(/[^0-9]/g, ""); // Only allow numbers
    if (value.length > 1) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Move to next input field if digit entered
    if (value && index < otp.length - 1) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };


  return (
    <div
      className={`relative flex w-full flex-col 
                        justify-start gap-2 lg:gap-1 px-3
                        py-2 lg:py-0 pb-5 xs:px-6 sm:px-9 md:w-[56%]  md:basis-[56%] md:pl-8  md:pr-12     lg:pl-8 lg:pr-14  xl:gap-4    xl:py-4
                        xl:pl-8                xl:pr-16     2xl:p-12 
                        2xl:py-14               2xl:pr-24 `}
    >
      <span
        onClick={() => {
          Dispatch(ResetLoginSignUp(false));
          Dispatch({ type: "LoginError", payload: {} }); // or use "ResetLoginError"

          setCredentials({
            Email: "",
            Password: "",
            ConfirmPassword: "",
            FirstName: "",
            LastName: "",
          });
          setErrors("");
        }}
        className="material-symbols-outlined absolute right-[1rem] top-[1rem] hidden cursor-pointer font-semibold text-primary md:block"
        style={{
          fontSize: "30px",
        }}
      >
        close
      </span>
      <p className=" w-full text-[30px] text-center lg:text-left mt-[30px] mb-[15px] lg:mt-[0px] lg:mb-[0px] font-bold  text-[white] md:text-[#5f56a8]	 lg:text-[20px] xl:text-[24px]">
      {userType === "Partner" ? "Partner " : "Learner "}
      {AuthPageName === "Sign Up" ? "Sign Up" : "Login"}
      </p>

      <p className=" w-full text-3xs  font-bold text-white underline decoration-4 underline-offset-8	 md:text-black lg:text-[16px] xl:text-[20px]">
        {AuthPageName === "Sign Up" ? "Sign Up " : AuthPageName + " "}
        Using Your Email
      </p>

      {/* <button type='button' className={`${TopLoginRegisterBtns} ${SignInbtnColor} -left-[1px] `}
                onClick={OnClick}
            >
                Sign In
            </button> */}

      <div>
        <div className={`flex flex-col items-start justify-between ${Gap}`}>
          <UserInput
            AuthPageName={AuthPageName}
            Credentials={Credentials}
            setCredentials={setCredentials}
            Errors={Errors}
            setErrors={setErrors}
            PasswordError={PasswordError}
            handleOTPChange={handleOTPChange}
            otp={otp}
            setOtpSent={setOtpSent}
            setOtpVerified={setOtpVerified}
          />

          <div className={`flex flex-col ${Gap}`}>
            {AuthPageName === "Sign Up" ? (
              <>
                <div className="">
                  {captchaError ? (
                    <h4 className="font-normal text-[red]"> {captchaError} </h4>
                  ) : null}
                  <ReCAPTCHA
                    sitekey={process.env.REACT_APP_GOOGLE_CAPTCHA_LIVE_KEY || "6Lecb_IoAAAAANjflXMmXPZiBMaU0clxSmxPG9f9"}
                    onChange={onChange}
                  />
                </div>
                <OnRegister
                  MobileDisplay={"hidden"}
                  DesktopDisplay={"inline"}
                  TermsDisplay={"flex"}
                  AuthPageName={AuthPageName}
                />
              </>
            ) : (
              <>
                <OnLogin setCredentials={setCredentials} />
                <div className="" >
                  {captchaError ? (
                    <h4 className="font-normal text-[red]"> {captchaError} </h4>
                  ) : null}
                  <ReCAPTCHA
                    sitekey={process.env.REACT_APP_GOOGLE_CAPTCHA_LIVE_KEY || "6Lecb_IoAAAAANjflXMmXPZiBMaU0clxSmxPG9f9"}
                    onChange={onChange}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        <SubmitButton ButtonType="submit" AuthPageName={AuthPageName} otpVerified={otpVerified} />

        <div className="flex w-full items-center justify-center">
          <p className="orlines text-center text-primary">Or</p>
        </div>

        <div className="flex items-center justify-center">
          <ContinueWithGoogle />
        </div>

        <div className="flex w-full items-center justify-center">
          <OtherOption
            // MobileDisplay={"hidden"}
            setCredentials={setCredentials}
            Credentials={Credentials}
            DesktopDisplay={"inline"}
            AuthPageName={AuthPageName}
            userType={userType}
          />
        </div>
        {/* {
                    AuthPageName === "Sign Up" ?
                        <>

                         

                            <button className={`w-full ${ButtonStyle} justify-start py-2 px-0 bg-white `}
                                onClick={() => {
                                    Dispatch(OpenLoginSignUp("Register", true));
                                    setCredentials({
                                        Email: "",
                                        Password: "",
                                        ConfirmPassword: "",
                                        FirstName: "",
                                        LastName: ""
                                    })
                                }}
                                type="button"
                            >
                                <img className='w-6 xl:w-10'
                                    src={require('../../../../Assets/Institute Icon.png')} alt=""
                                />
                                <h5 className={` ${h4Style} inline-block`}>
                                    Register as a Partner
                                </h5>
                            </button>

                        </>
                        : null
                } */}

        {/* <button
          type="submit"
          className="Boldfont mt-6 inline-block w-full cursor-pointer rounded-[12px] border-none py-3 text-4xs text-[#521E9D] md:hidden"
        >
          {AuthPageName === "Sign Up" ? "Sign Up" : "Sign in"}
        </button> */}
      </div>
    </div>
  );
};
export default SigninRightSide;
